<template>
    <layout-internal-container>
        <div class="w-full flex flex-col gap-6">
            <div class="flex flex-col gap-4 md:flex-row justify-between md:items-center">
                <span class="text-sm font-medium text-light">Your Recently Joined Program</span>
                <div @click="$router.push('/Program/Discovery')"
                    class="text-primary flex flex-row justify-center cursor-pointer text-sm items-center gap-2 w-fit"
                    v-if="myPrograms.length > 0"
                >
                    <span class="font-medium">Explore New Program</span>
                    <IconArrowRight :size="18" />
                </div>
            </div>
            <div class="w-full flex-col flex gap-8 bg-white">
                <div class="w-full flex flex-col md:flex-row justify-end gap-6">
                    <div class="flex flex-col md:flex-row gap-2 md:items-center">
                        <span class="text-sm text-light font-medium min-w-max">Status :</span>
                        <a-select placeholder="Select" class="w-full md:w-[12rem]" @change="onChangeStatus">
                            <a-select-option value="Upcoming">Upcoming</a-select-option>
                            <a-select-option value="Ongoing">Ongoing</a-select-option>
                            <a-select-option value="Ended">Ended</a-select-option>
                        </a-select>
                    </div>
                    <div class="flex flex-col md:flex-row gap-2 md:items-center">
                        <span class="text-sm text-light font-medium min-w-max">Type :</span>
                        <a-select placeholder="Select" class="w-full md:w-[12rem]" @change="onChangeType">
                            <a-select-option value="Accelerator">Acceleration</a-select-option>
                            <a-select-option value="Incubator">Incubation</a-select-option>
                        </a-select>
                    </div>
                </div>

                <div v-if="isProgramsLoaded">
                    <div class="w-full gap-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3" v-if="myPrograms.length > 0">
                        <card-program v-for="item in myPrograms" enrolled :statusEnrolled="item.program.isEnrolled" :key="item.program.id" :name="item.program.title"
                            :id="item.program.id" :slug="item.program.slug" :image="item.program.photo" :type="item.program.type" :description="item.program.short_desc"
                            :status="item.program.status" :date="moment(item.program.start_date).format('MMM DD, YYYY')" :batch="item.program.batch" />
                    </div>
    
                    <div class="w-full gap-2 flex flex-row items-center justify-center mt-8" v-else>
                        <p>No Program Found.</p>

                        <div @click="$router.push('/Program/Discovery')" class="text-primary flex flex-row justify-center cursor-pointer text-sm items-center gap-1">
                            <p>Explore new program</p>
                            <IconArrowRight :size="18" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </layout-internal-container>
</template>
  
<script setup>
    import { ref, onMounted } from 'vue'
    import axios from "@/plugins/axios";
    import { IconArrowRight } from '@tabler/icons-vue'
    import moment from 'moment';

    const tab = ref('All')
    const myPrograms = ref([])
    const status = ref('')
    const type = ref('')
    const isProgramsLoaded = ref(false)

    const fetchPrograms = async () => {
        try {
            const response = await axios.get('/my-program', {
                params: {
                    status: status.value,
                    type: type.value,
                }
            })

            myPrograms.value = response?.data?.data

            isProgramsLoaded.value = true
        } catch (error) {
            console.error('Error fetching my programs:', error)
        }
    }

    const onChangeStatus = (value) => {
        status.value = value
        fetchPrograms()
    }

    const onChangeType = (value) => {
        type.value = value
        fetchPrograms()
    }

    onMounted(fetchPrograms)

</script>
  